// dynamically import RPSAIBlockComponent and export
import dynamic from 'next/dynamic';
import { BlockProps } from '@/components/Block/Block';

const RPSAIBlockComponent = dynamic<BlockProps>(
    () => import('./RPSAIBlockComponent'),
    { ssr: false },
);

export default RPSAIBlockComponent;
